var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.61 201.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4e6ef;\n      }\n\n      .cls-2 {\n        fill: #72a1c2;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #97bcd7;\n      }\n\n      .cls-5 {\n        fill: #00263e;\n      }\n\n      .cls-6 {\n        fill: #1e5c8f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.75,59.21v72.59c0,1.73-.95,3.32-2.48,4.13l-71.03,37.85c-1.38.73-3.03.73-4.41,0l-71.03-37.85c-1.53-.81-2.48-2.4-2.48-4.13V59.21c0-1.73.95-3.32,2.48-4.13L90.83,17.22c1.38-.73,3.03-.73,4.41,0l71.03,37.86c1.53.81,2.48,2.4,2.48,4.13Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.38 138.36 50.38 138.36 93.03 115.63 135.68 138.36 135.68 138.36 93.03 161.09 50.38 138.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.55 63.74 29.55 63.82 39.97 58.27 54.5 66.29 93.03 45.76 131.56 66.29 146.1 58.27 156.51 63.82 156.51 63.74 93.03 29.91 29.55 63.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.57 99.08 93.03 78.58 131.49 99.08 131.49 66.33 131.56 66.29 93.03 45.76 54.5 66.29 54.57 66.33 54.57 99.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.57 99.08 54.57 136.13 93.03 115.63 131.49 136.13 131.49 99.08 93.03 78.58 54.57 99.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.97 58.27 29.55 63.82 29.55 79.59 54.5 66.29 39.97 58.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "54.57 66.33 54.5 66.29 29.55 79.59 29.55 112.42 54.57 99.08 54.57 66.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.38 138.36 54.57 136.13 54.57 99.08 29.55 112.42 29.55 127.26 50.38 138.36 50.38 138.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.56 66.29 156.51 79.59 156.51 63.82 146.1 58.27 131.56 66.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.49 66.33 131.49 99.08 156.51 112.42 156.51 79.59 131.56 66.29 131.49 66.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.68 138.36 131.49 136.13 131.49 99.08 156.51 112.42 156.51 127.26 135.68 138.36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e7ce769f4fec6fc362c3f0957a9e43fc.svg";
export { ForwardRef as ReactComponent };